import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

import beneficiaryStatus from 'constants/beneficiaryStatus';

type Props = {
  data: {
    beneficiaryData: Record<string, any>;
    status: string;
  };
  actions: {
    handleGoBack: () => void;
  };
};

type Status = 'ACTIVE' | 'PAUSED' | 'DRAFT' | 'CANCELED' | 'CONSOLIDATED';

type BeneficiaryBadgeProps = {
  status: Status;
};

const BeneficiaryBadge = ({ status }: BeneficiaryBadgeProps) => {
  const statusStyle = beneficiaryStatus.style[status];
  const statusLabel = beneficiaryStatus.name[status];

  return (
    <span className={`badge rounded-pill text-${statusStyle}`}>
      {statusLabel}
    </span>
  );
};

const BeneficiaryDetailsHeader: FC<Props> = ({ data, actions }) => {
  const { t } = useTranslate();

  const { beneficiaryData, status } = data;
  const { handleGoBack } = actions;

  return (
    <>
      <div className="nk-block-head">
        <div className="nk-block-between g-3">
          <div className="nk-block-head-content">
            <h3 className="nk-block-title page-title">
              {beneficiaryData?.isDraft ? `${t('BeneficiariesDraft')} ` : ''}
              {t('Beneficiary')} /{' '}
              <strong className="text-primary small mr-2">
                {beneficiaryData.name || ''}
              </strong>
              <BeneficiaryBadge status={status as Status} />
              {beneficiaryData?.isDraft && (
                <span
                  className={`badge rounded-pill bg-${beneficiaryStatus.style.DRAFT} text-white ml-1`}
                >
                  {beneficiaryStatus?.name.DRAFT}
                </span>
              )}
            </h3>
          </div>

          <div className="nk-block-head-content">
            <span
              className="btn btn-outline-light bg-white d-none d-sm-inline-flex"
              onClick={handleGoBack}
            >
              <em className="icon ni ni-arrow-left" />
              <span>{t('Back')}</span>
            </span>
            <span
              className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"
              onClick={handleGoBack}
            >
              <em className="icon ni ni-arrow-left" />
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default BeneficiaryDetailsHeader;
